import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../../services/authService';
import { getErrorMessage } from '../../api/client';

const AdminLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleChange = (event) => {
    const { name, value } = event.target;

    setCredentials((currentCredentials) => ({
      ...currentCredentials,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const result = await login(credentials.email.trim(), credentials.password);
      onLogin(result.token, result.admin);
      navigate('/admin');
    } catch (submitError) {
      setError(getErrorMessage(submitError, 'Invalid email or password.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="theme-page d-flex align-items-center justify-content-center px-3">
      <section className="theme-card theme-login-card w-100 text-center p-4 p-sm-5">
        <p className="theme-eyebrow mb-2">SRK Production</p>
        <h1 className="theme-title mb-3">Admin Login</h1>
        <p className="theme-copy mb-4">Sign in to view registered participant records.</p>

        <form onSubmit={handleSubmit} className="d-flex flex-column gap-3 text-start">
          <div>
            <label htmlFor="adminEmail" className="form-label text-white fw-bold">
              Email
            </label>
            <input
              id="adminEmail"
              type="email"
              name="email"
              className="form-control theme-field px-3"
              value={credentials.email}
              onChange={handleChange}
              autoComplete="username"
              required
            />
          </div>

          <div>
            <label htmlFor="adminPassword" className="form-label text-white fw-bold">
              Password
            </label>
            <input
              id="adminPassword"
              type="password"
              name="password"
              className="form-control theme-field px-3"
              value={credentials.password}
              onChange={handleChange}
              autoComplete="current-password"
              required
            />
          </div>

          {error && <div className="theme-state theme-error text-center p-3">{error}</div>}

          <button type="submit" className="btn theme-btn theme-btn-primary w-100 mt-2 text-uppercase" disabled={isSubmitting}>
            {isSubmitting ? 'Signing in...' : 'Login'}
          </button>
        </form>
      </section>
    </div>
  );
};

export default AdminLogin;
